export const Copy = {
  title: "Medical History",
  description: {
    minor:
      "Select any conditions listed below that apply to the minor who will be having this procedure.",
    self: "Select any conditions listed below that apply to you.",
  },
};
